package org.zest.insan_360_website.model

import kotlinx.serialization.Serializable
import kotlinx.datetime.Instant

enum class CreditStatus { ACTIVE, IN_PROGRESS, USED, EXPIRED }

// no credit status request model

@Serializable
data class ChangeCreditStatusRequest(
    val email: String,
    val changeTo: CreditStatus
)

@Serializable
data class CreditHistory(
    val creditId: String? = null,
    val paymentId: String,
    val referenceId: String,
    val status: String,
    val purchaseAt: Instant,
    val usedAt: Instant? = null,
)

@Serializable
data class CreditsHistoryPayload(
    val credits: List<CreditHistory>
)

@Serializable
data class CreditSessionPayload(
    val hasActiveSession: Boolean,
    val sessionExpiresAt: Instant? = null,
    val serverTimeAtResponse: Instant? = null,
    val extensionCount: Int = 0
)